import { Subject } from 'rxjs'
import apiResponse from "../../../../services/apiResponse"
import Penilaian360Repository from '../Repositories/Penilaian360Repository'


class Penilaian360Bloc
{
    repository = new Penilaian360Repository()
    dashboardChannel = new Subject()

    constructor(){
        this.dashboardChannel.next({status: apiResponse.INITIAL})
    }

    fetchDashboard = async (query) => {
        this.dashboardChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDashboard(query).then((result) => {
            this.dashboardChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.dashboardChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

}


export default Penilaian360Bloc